import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsal } from '@/config/msalConfig';
import App from './App';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { initAppInsights } from '@/telemetry/appInsights';
import './index.css';

// Browser exception telemetry (no-op unless VITE_APPINSIGHTS_CONNECTION_STRING is set)
initAppInsights();

initializeMsal().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
});
